import { render } from "./BulletinBoard.vue?vue&type=template&id=3593facd&scoped=true"
import script from "./BulletinBoard.vue?vue&type=script&lang=js"
export * from "./BulletinBoard.vue?vue&type=script&lang=js"

import "./BulletinBoard.vue?vue&type=style&index=0&id=3593facd&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3593facd"]])

export default __exports__